module.exports = __webpack_public_path__ + "img/lab3.ef910bfe.png";